import type { ApiOtpReference } from 'src/types/userAuth';

import { useMutation } from '@tanstack/react-query';

import axios from 'src/utils/axios';

/** POST /user/auth/login/resend — re-sends the OTP for an existing reference. */
export const useResendUserOtp = () =>
  useMutation({
    mutationFn: async (reference: string): Promise<ApiOtpReference> => {
      const response = await axios.post<ApiOtpReference>(`/user/auth/login/resend`, { reference });
      return response.data;
    },
  });
